/**
 * Event name constants for LoanLight components
 * Centralized event names for type safety and easy refactoring
 */

export const LOANLIGHT_EVENTS = {
  BUTTON_CLICK: "loanlight-click",
  INPUT_CHANGE: "loanlight-input-change",
  TABLE_SORT: "loanlight-sort",
  TABLE_ROW_CLICK: "loanlight-row-click",
  TABLE_VIEW_DOCUMENT: "loanlight-view-document",
  PANEL_TOGGLE: "loanlight-panel-toggle",
  PANEL_OPTION_SELECTED: "loanlight-option-selected",
  AUDIT_CREATE: "audit-create",
  AUDIT_UPDATE: "audit-update",
  NAVIGATE: "navigate",
  UPDATE_APPLICATION_STATE: "update-application-state",
  AUDIT_DATA_LOADED: "audit-data-loaded",
  AUDIT_DATA_ERROR: "audit-data-error",
  LOANLIGHT_ERROR: "loanlight-error",
  MODAL_OPEN: "loanlight-modal-open",
  MODAL_CLOSE: "loanlight-modal-close",
  MODAL_BACKDROP_CLICK: "loanlight-modal-backdrop-click",
} as const;
